import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle } from 'lucide-react';

const notifications = [
  { name: 'Priya', city: 'Mumbai', action: 'just got a salon website' },
  { name: 'Rahul', city: 'Delhi', action: 'booked a free consultation' },
  { name: 'Sneha', city: 'Bangalore', action: 'launched her clinic website' },
  { name: 'Amit', city: 'Hyderabad', action: 'upgraded to Professional plan' },
  { name: 'Kavya', city: 'Pune', action: 'got 15+ bookings from her new site' },
  { name: 'Arjun', city: 'Chennai', action: 'just got a spa website' },
  { name: 'Neha', city: 'Jaipur', action: 'started her free consultation' },
  { name: 'Vikram', city: 'Ahmedabad', action: 'launched his fitness website' }
];

const SocialProof = () => {
  const [current, setCurrent] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (dismissed) return;

    const showTimer = setTimeout(() => {
      setVisible(true);
    }, 8000);

    return () => clearTimeout(showTimer);
  }, [dismissed]);

  useEffect(() => {
    if (dismissed || !visible) return;

    const hideTimer = setTimeout(() => {
      setVisible(false);
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % notifications.length);
        setVisible(true);
      }, 2000);
    }, 6000);

    return () => clearTimeout(hideTimer);
  }, [visible, current, dismissed]);

  if (dismissed) return null;

  const notification = notifications[current];

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ x: 120, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 120, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 300, damping: 25 }}
          className="fixed bottom-24 left-6 z-[90] max-w-xs"
          data-testid="social-proof-notification"
        >
          <div className="bg-white rounded-2xl shadow-2xl border border-neutral-100 p-4 flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
              <CheckCircle className="w-5 h-5 text-accent-600" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-neutral-800">
                {notification.name} from {notification.city}
              </p>
              <p className="text-xs text-neutral-500 mt-0.5">
                {notification.action}
              </p>
              <p className="text-xs text-neutral-400 mt-1">Just now</p>
            </div>
            <button
              onClick={() => setDismissed(true)}
              className="text-neutral-300 hover:text-neutral-500 flex-shrink-0"
              data-testid="social-proof-dismiss"
              aria-label="Dismiss notification"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SocialProof;
